import classNames from 'classnames';
import React from 'react';
import { Tab } from '../components/Tabs';
import * as styles from './SearchPlatformTab.module.scss';

interface SearchPlatformTabProps {
  icon?: React.ReactNode;
  meta?: React.ReactNode;
  name: string;
  active: boolean;
  onClick: () => void;
  className?: string;
  activeClassName?: string;
}

const SearchPlatformTab = ({
  icon,
  meta,
  name,
  active,
  onClick,
  className,
  activeClassName,
}: SearchPlatformTabProps) => (
  <Tab
    onlyActiveOnSearchMatch
    className={classNames(className ?? styles.tab, {
      [activeClassName ?? styles.activeTab]: active,
    })}
    onClick={onClick}
    active={active}
  >
    <div className={styles.searchPlatform}>
      {!!icon && <span>{icon}</span>}
      <span className={styles.searchPlatformName}>{name}</span>
      {meta != null && <span className={styles.meta}>{meta}</span>}
    </div>
  </Tab>
);

export default SearchPlatformTab;
